'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var textractStatus = exports.textractStatus = {
  ERROR: 'ERROR',
  APPROVED: 'APPROVED',
  PENDING: 'PENDING'

};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/utilities/textract-statuses.js
// module id = 161
// module chunks = 0